import { render, staticRenderFns } from "./wxTipDialog.vue?vue&type=template&id=ea5ae742&scoped=true"
import script from "./wxTipDialog.vue?vue&type=script&lang=ts"
export * from "./wxTipDialog.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./wxTipDialog.vue?vue&type=style&index=0&id=ea5ae742&prod&scoped=true&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "ea5ae742",
  "0c15a9e3"
  
)

export default component.exports